import CheckCreditScore from 'features/creditScore/CheckCreditScore/CheckCreditScore';
import React from 'react';

export default function CreditScorePage() {
  return <CheckCreditScore />;
}
